import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20warm%20orange%20and%20amber%20sunset%20sky%20with%20towering%20glowing%20clouds%20and%20radiant%20light%20rays%20over%20a%20quiet%20town%20skyline%2C%20stylized%20painterly%20anime%20background%20art%2C%20no%20characters%2C%20cinematic%20wide%20composition%2C%20rich%20contrast%20for%20text%20overlay&width=1920&height=1080&seq=hero-family-tutor-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-accent-950/50 via-transparent to-primary-950/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16">
        <div className="max-w-6xl mx-auto">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm mb-5 animate-float">
            <i className="ri-fire-line" />
            热血 · 搞笑 · 黑手党 · 成长
          </span>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl leading-tight text-background-50 drop-shadow-lg">
            我的家庭教师
          </h1>
          <p className="mt-3 font-heading text-lg md:text-2xl text-primary-200">
            家庭教师HITMAN REBORN! — 从废柴少年到十代首领的成长之旅
          </p>
          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
            本站为你整理《我的家庭教师》的动漫在线观看渠道、全集资源与未删减版说明，并汇总樱花动漫、风车动漫等常见播放地址线索。
            无论你是第一次补番，还是想重温这段热血又搞笑的经典，都能在这里快速找到清晰的方向。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#channels"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-circle-line text-lg" />
              查看观看渠道
            </a>
            <a
              href="#story"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 text-background-50 border border-background-50/40 text-sm md:text-base whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-book-open-line text-lg" />
              了解故事内容
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-3xl">
            {heroStats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur px-4 py-3"
              >
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl md:text-3xl text-background-50">{s.value}</span>
                  <span className="text-xs text-primary-200">{s.unit}</span>
                </div>
                <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}